@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;

  &.is-loading {
    .chart-legend,
    .chart-content {
      display: none;
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 1.5);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .widget-chart {
    width: 100%;

    .bb-axis {
      &-x {
        .tick {
          text {
            fill: var(--body-text-arrows-400) !important;

            tspan {
              font-family: var(--font-family-secondary);
              font-size: var(--body-size);
            }
          }
        }
      }

      .tick {
        text {
          fill: var(--main-titles-inputs-600);
          font-family: var(--font-family-secondary);
          font-size: var(--body-size);
        }
      }

      &-y .tick text tspan {
        font-family: var(--font-family-secondary-mono);
        font-size: var(--body-size-small);
      }
    }

    svg {
      width: 100%;
    }
    .bb-main {
      width: 100%;
    }
  }

  .chart-legend {
    display: inline-flex;
    justify-content: flex-start;
    padding-left: calc(var(--spacer) * 2);
    margin-top: calc(var(--spacer) * 3);

    .gz-data-item {
      margin-bottom: 0;
      margin-right: calc(var(--spacer) * 4);
    }
  }

  .chart-content {
    display: flex;
    align-items: center;
    margin-left: -10px;
    margin-top: calc(var(--spacer) * 1);
  }
}

.chart-tooltip-container {
  min-width: 220px;
}

.bb-tooltip-container {
  background-color: var(--white-layout-303-level-2-elevation);
  transform: translateY(-40%);
}

@media screen and (max-width: 1920px) {
  .content {
    .widget-chart {
      &--active {
        .bb-axis-x {
          .tick {
            text {
              text-anchor: end !important;
              transform: rotate(-35deg) translateY(3px) translateX(3px);
            }
          }
        }
      }
    }
  }
}

:host([data-display-mode='pdf']) {
  .bb-legend-item {
    font-size: calc(var(--body-size) - 2px);
  }
  .gz-data-item--bullet {
    margin-top: 0;
  }
  .content .widget-chart--active .bb-axis-x .tick text {
    font-size: calc(var(--body-size) - 4px);
    //transform: rotate(-44deg) translateY(-3px) translateX(3px);
    transform: rotate(-55deg) translateY(-5px) translateX(1px);

    tspan {
      font-size: calc(var(--body-size) - 2px);
    }
  }
}
